import React, {
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

import type {
  EvaluationExplainabilityContextProps,
  EvaluationExplainabilityContextProviderProps,
  EvaluationExplainabilityState,
} from './types';

const initialEvaluationExplainabilityState = {
  entityToken: null,
  evaluationTags: null,
  evaluationToken: null,
  tagDescription: null,
  actionName: null,
  workflowToken: null,
  workflowVersion: null,
};

export const EvaluationExplainabilityContext = createContext<EvaluationExplainabilityContextProps>({
  evaluationExplainabilityState: initialEvaluationExplainabilityState,
  setEvaluationExplainabilityState: () => {},
} as EvaluationExplainabilityContextProps);

export const useEvaluationExplainabilityContext = () => useContext(EvaluationExplainabilityContext);

export default function EvaluationExplainabilityContextProvider({
  children,
}: EvaluationExplainabilityContextProviderProps) {
  const [
    evaluationExplainabilityState,
    setEvaluationExplainabilityState,
  ] = useState<EvaluationExplainabilityState>(initialEvaluationExplainabilityState);

  const value = useMemo(() => ({
    evaluationExplainabilityState,
    setEvaluationExplainabilityState,
  }), [
    evaluationExplainabilityState,
    setEvaluationExplainabilityState,
  ]);

  return (
    <EvaluationExplainabilityContext.Provider
      value={value}
    >
      {children}
    </EvaluationExplainabilityContext.Provider>
  );
}
